import Api from "../api";
let uri = "/api/ed/capacitacion/presencial/participante";

export const getMisCapacitacionesPresenciales = (dpi) => {
  return Api.getInstance()
    .executeGetQuery(`${uri}/${dpi}`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const updateParticipanteMostrado = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(`${uri}/mostrado`, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};